import React, { Component } from 'react';
import propsTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import {Row , Col, Table, Panel, Alert, Modal} from 'react-bootstrap';
import TagsInput from 'react-tagsinput';
import { withRouter } from 'react-router';
import 'react-tagsinput/react-tagsinput.css';
import Autosuggest from 'react-autosuggest';

import { loginUser, logoutUser, registerUser } from '../actions/userActions';
import { fetchSubjects } from '../actions/subjectActions';
import { newError } from '../actions/errorActions';
import { fetchTagIds, fetchTagCounts } from '../actions/tagActions';
import { fetchErrorsFilter } from '../actions/errorActions';
import { getInputHistory, setInputHistory } from '../actions/inputActions';


class ErrorInput extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: {},
      tags: [],
      tag_list: [],
      subject: 0,
      tag_suggestions: [],
      isWaiting: false,
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleTagChange = this.handleTagChange.bind(this);
    this.onSubjectChange = this.onSubjectChange.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({tag_list: newProps.tags});
    if (JSON.stringify(newProps.error) !== JSON.stringify(this.props.error)) {
      if (Object.keys(this.props.userinfo)!==0) {
        this.setState({isWaiting:false,});
        this.props.fetchErrorsFilter(this.props.userinfo.token,'id='+newProps.error.id);
        this.props.fetchTagCounts(this.props.userinfo.token);
        console.log(newProps.error.id);
        this.props.history.push(`/error/`+newProps.error.id);
      }
    }
  }

  componentWillMount() {
    if ((Object.keys(this.props.userinfo)!==0) && ('token' in this.props.userinfo)) {
      this.props.fetchSubjects(this.props.userinfo.token);
      this.props.fetchTagCounts(this.props.userinfo.token);
    }
  }

  componentDidMount() {
    var error = this.state.error;
    /* 根据输入历史赋错题科目、日期、来源、题型的初始值 */
    if ('subject' in this.props.inputHistory) {
      error['subject'] = parseInt(this.props.inputHistory.subject,0);
      this.setState({'subject': parseInt(this.props.inputHistory.subject,0)});
    }
    if ('ddate' in this.props.inputHistory) {
      error['ddate'] = this.props.inputHistory.ddate;
    }
    if ('source' in this.props.inputHistory) {
      error['source'] = this.props.inputHistory.source;
    }
    if ('question_type' in this.props.inputHistory) {
      error['question_type'] = this.props.inputHistory.question_type;
    }
    this.setState({error:error});
    /* 加载知识点提示库 */
    if (Object.keys(this.props.tags)!==0) {
      let hit_suggestions = this.props.tags.find(s=>parseInt(s.id,0)===parseInt(error['subject'],0));
      if (hit_suggestions) {
        this.setState({tag_suggestions:hit_suggestions.tags})
      }
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    var days = 36135;
    if ('token' in this.props.userinfo) {
      if ('to_date' in this.props.validity[0]) {
        days = moment(this.props.validity[0].to_date,"YYYY-MM-DD").diff(moment(),'days');
      }
    }
    if (days<=0) {
      alert('您的账户已过有效期，需充值后才可继续输入错题。');
      this.props.history.push('/pay');
    }
    if ((Object.keys(this.props.userinfo).length!==0) && ('token' in this.props.userinfo)) {
      if ((this.state.tags.length === 0) || (!('question_type' in this.state.error)) || (!('ddate' in this.state.error)) || (!('source' in this.state.error)) || (!('subject' in this.state.error))) {
        alert('数据未保存，因为缺少以下信息中的一个或多个：\n错题科目、错题日期、错题来源、错题题型、知识点。')
      } else {
        let error = this.state.error;
        this.props.setInputHistory({
          'subject': error.subject,
          'ddate': error.ddate,
          'source': error.source,
          'question_type': error.question_type
        });
        let formData = new FormData();
        for (var key in error) {
          if (key.includes('img')) {
            formData.append(key,error[key].blob,error[key].filename)
          } else {
            formData.append(key, error[key])
          }
        }
        var tmp_list = [];
        this.state.tag_list.forEach((tag)=>{
          tmp_list.push(parseInt(tag.id,0));
        });
        for (var i=0; i<tmp_list.length; i++){
          formData.append('tags',tmp_list[i]);
        }
        this.setState({isWaiting:true,});
        this.props.newError(this.props.userinfo.token, formData);
        }
    } else {
      alert("请先登录或注册。");
      this.props.history.push(`/user_login`);
    }
  }

  handleCancel(event) {
    this.props.history.push(`/`);
  }

  handleChange(event) {
    var error = this.state.error;
    /* 判断是否为图片输入 */
    if ((event.target.id) && (!event.target.id.includes('img'))) { /* 不是 */
      const field = event.target.id;
      error[field] = event.target.value.trim();
      this.setState({error:error,})
    } else { /* 是 */
      if (event.target.id.includes('img')) {
        /* 开始：处理图像 */
        var field = event.target.id;
        var preview = document.getElementById(field + '_preview');
        var file = event.target.files[0];
        /* 文件名，扩展名为jpeg */
        var filename = event.target.files[0].name.split('.')[0]+'.jpeg';
        var reader = new FileReader();
        reader.onload = function(readerEvent) {
          var image = new Image();
          image.onload = function(imageEvent) {
            var canvas = document.createElement('canvas');
            var max_size = 800; /* 最大尺寸800 */
            var width = image.width, height = image.height;
            /* 分别设置画布尺寸 */
            if (width > height) {
              if (width > max_size) {
                height *= max_size / width;
                width = max_size;
              }
            } else {
              if (height > max_size) {
                width *= max_size / height;
                height = max_size;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL("image/jpeg");
            canvas.toBlob(function(blob){
              var image_data = {'filename':filename,'blob':blob}
              error[field] = image_data;
              var reader1 = new FileReader();
              reader1.addEventListener("load",function(){
                preview.src = dataUrl;
              }, false);
              reader1.readAsDataURL(blob);
            },"image/jpeg",0.9);
          }
          image.src = readerEvent.target.result;
        }
        reader.readAsDataURL(file);
        this.setState({error:error,})
      }
    }
  }

  handleTagChange(tags) {
    this.setState({tags});
    let tmpstr = this.state.subject + ' ';
    tags.forEach((t)=>{
     tmpstr = tmpstr + t + ' ';
    });
    this.props.fetchTagIds(this.props.userinfo.token,tmpstr);
    if (Object.keys(this.props.tags)!==0) {
      this.setState({tag_list: this.props.tags})
    }
  }

  onSubjectChange(event) {
    this.setState({subject: event.target.value,});
    var error = this.state.error;
    error.subject = event.target.value;
    this.setState({error:error});
    if (Object.keys(this.props.tags)!==0) {
      let hit_suggestions = this.props.tags.find(s=>parseInt(s.id,0)===parseInt(event.target.value,0));
      if (hit_suggestions) {
        this.setState({tag_suggestions:hit_suggestions.tags})
      }
    }
  }

  onTagsChange(event) {
    this.setState({tags:event.target.value,})
  }

  render() {
    /* tag autocomplete */
    let tag_suggestions = this.state.tag_suggestions;
    function autocompleteRenderInput({addTag, ...props}) {
      const handleOnChange = (e, {newValue, method}) => {
        if (method === 'enter') {
          e.preventDefault()
        } else {
          props.onChange(e)
        }
      }
      const inputValue = (props.value && props.value.trim().toLowerCase()) || '';
      const inputLength = inputValue.length;
      let suggestions = [];
      if (tag_suggestions.length>0) {
        suggestions = tag_suggestions.filter((tag)=>{
          return tag.value.toLowerCase().slice(0, inputLength) === inputValue
        });
      }
      return (
        <Autosuggest
          ref={props.ref}
          suggestions={suggestions}
          shouldRenderSuggestions={(value)=>value&&value.trim().length>0}
          getSuggestionValue={(suggestion)=>suggestion.value}
          renderSuggestion={(suggestion)=><span>{suggestion.value}</span>}
          inputProps={{...props,onChange:handleOnChange}}
          onSuggestionSelected={(e,{suggestion})=>{
            addTag(suggestion.value)
          }}
          onSuggestionsClearRequested={()=>{}}
          onSuggestionsFetchRequested={()=>{}}
        />
      )
    }

    /* 课程列表 */
    let subjectOptions = [];
    /* console.log(this.props.subjects); */
    ((Object.keys(this.props.subjects)!==0) && (Object.keys(this.props.userinfo)!==0) && ('token' in this.props.userinfo)) ? 
        subjectOptions=(this.props.subjects.map((subject)=>
          <option
            key={subject.id}
            id={subject.id}
            value={subject.id}
          >
            {subject.name}
          </option>))
        :
        (subjectOptions=[]);
    return (
          <Panel>
          <Panel.Heading>
            <h3>错题输入</h3>
            {('token' in this.props.userinfo)?'':<Alert bsStyle="warning">您需要先登录才能输入并保存错题.</Alert>}
          </Panel.Heading>
          <Panel.Body>
          <div>
            <Row className="error">
              <form
                method="POST"
                encType="multipart/form-data"
                id="fileUploadForm"
                onSubmit={this.handleSubmit}
              >

              <Col xs={12} md={4}>
                <div className="error" style={{border: "1px solid"}}>
                  <Table striped bordered condensed hover>
                  <tbody>
                    <tr><td>
                      <label>错题科目
                        <select 
                          id="subject" 
                          onChange={this.onSubjectChange}
                          defaultValue={('subject' in this.props.inputHistory) ? parseInt(this.props.inputHistory.subject,0) : 0}
                        >
                          <option value="0">请选择科目</option>
                          { subjectOptions }
                        </select>
                      </label>
                    </td></tr>
                    <tr><td>
                      <label>错题日期
                        <input
                          id="ddate"
                          type="date"
                          defaultValue={('ddate' in this.props.inputHistory)? this.props.inputHistory.ddate : ''}
                          onChange={this.handleChange}
                        />
                       </label>
                    </td></tr>
                    <tr><td>
                      <label>错题来源
                        <input
                          id="source"
                          type="text"
                          defaultValue={('source' in this.props.inputHistory)? this.props.inputHistory.source : ''}
                          onChange={this.handleChange}
                        />
                      </label>
                    </td></tr>
                    <tr><td>
                      <label>错题题型
                        <input
                          id="question_type"
                          type="text"
                          defaultValue={('question_type' in this.props.inputHistory)? this.props.inputHistory.question_type : ''}
                          onChange={this.handleChange}
                        />
                      </label>
                    </td></tr>
                  </tbody>
                  </Table>
                </div>
              </Col>
              <Col xs={12} md={8}>
                <div className="error" style={{border: "1px solid", margin_left:"5px"}}>
                  <Table  striped bordered condensed hover>
                  <tbody>
                    <tr><td>
                      <label>错题描述<br/>
                      <textarea style={{width:"100%"}}
                        id="question_txt"
                        rows="4"
                        onChange={this.handleChange}
                      />
                    </label><br/>
                    </td></tr>
                    <tr><td>
                    <label>错题描述图片1
                    <input
                      type="file"
                      id="question_img1"
                      onChange={this.handleChange}
                    />
                    </label>
                    <br/>
                    <img id="question_img1_preview" src="" height="100" alt="图像预览..."></img>
                    </td></tr>
                    <tr><td>
                    <label>错题描述图片2
                    <input
                      type="file"
                      id="question_img2"
                      onChange={this.handleChange}
                    />
                    </label>
                    <br/>
                    <img id="question_img2_preview" src="" height="100" alt="图像预览..."></img>
                    </td></tr>
                    <tr><td>
                    <label>我的答案<br/>
                    <textarea
                      id="error_answer_txt"
                      rows="4"
                      cols="20"
                      onChange={this.handleChange}
                    />
                    </label>
                    </td></tr>
                    <tr><td>
                    <label>我的答案图片1
                      <input
                        type="file"
                        id="error_answer_img1"
                        onChange={this.handleChange}
                      />
                    </label>
                    <br/>
                    <img id="error_answer_img1_preview" src="" height="100" alt="图像预览..."></img>
                    </td></tr>
                    <tr><td>
                    <label>我的答案图片2
                    <input
                      type="file"
                      id="error_answer_img2"
                      onChange={this.handleChange}
                    />
                    </label>
                    <br/>
                    <img id="error_answer_img2_preview" src="" height="100" alt="图像预览..."></img>
                    </td></tr>
                    <tr><td>
                    <label>正确答案<br/>
                    <textarea
                      id="correct_answer_txt"
                      rows="4"
                      onChange={this.handleChange}
                    />
                    </label>
                    </td></tr>
                    <tr><td>
                    <label>正确答案图片1
                    <input
                      type="file"
                      id="correct_answer_img1"
                      onChange={this.handleChange}
                    />
                    </label>
                    <br/>
                    <img id="correct_answer_img1_preview" src="" height="100" alt="图像预览..."></img>
                    </td></tr>
                    <tr><td>
                    <label>正确答案图片2
                    <input
                      type="file"
                      id="correct_answer_img2"
                      onChange={this.handleChange}
                    />
                    </label>
                    <br/>
                    <img id="correct_answer_img2_preview" src="" height="100" alt="图像预览..."></img>
                    </td></tr>
                    <tr><td>
                    <label>答题思路<br/>
                    <textarea
                      id="method"
                      rows="4"
                      onChange={this.handleChange}
                    />
                    </label>
                    </td></tr>
                    <tr><td>
                    <label>知识点(输入每个知识点后回车)<br/>
                    <TagsInput
                      value={this.state.tags}
                      renderInput={autocompleteRenderInput}
                      onChange={this.handleTagChange}
                    />
                    </label>
                    </td></tr>
                    <tr><td>
                    <input
                      type="button"
                      value="保存"
                      id="btnSubmit"
                      onClick={this.handleSubmit}
                    />
                    <input
                      type="button"
                      value="取消"
                      id="btnCancel"
                      onClick={this.handleCancel}
                    />
                    </td></tr>
                  </tbody>
                  </Table>
                </div>
              </Col>
              </form>
            </Row>
          </div>
          </Panel.Body>
          <Modal show={this.state.isWaiting}>
            <Modal.Body>
              数据上传中，请稍等...
            </Modal.Body>
          </Modal>
          </Panel>
      )
    }
}


ErrorInput.propsTypes = {
  loginUser: propsTypes.func.isRequired,
  registerUser: propsTypes.func.isRequired,
  logoutUser: propsTypes.func.isRequired,
  fetchSubjects: propsTypes.func.isRequired,
  newError: propsTypes.func.isRequired,
  fetchTagIds: propsTypes.func.isRequired,
  fetchErrorsFilter: propsTypes.func.isRequired,
  getInputHistory: propsTypes.func.isRequired,
  setInputHistory: propsTypes.func.isRequired,
  subjects: propsTypes.list,
  error: propsTypes.object,
  userinfo: propsTypes.object,
  inputHistory: propsTypes.object,
  validity: propsTypes.object,
  tags: propsTypes.list
}

const mapStateToProps = state => ({
  userinfo: state.users.item,
  subjects: state.subjects.items,
  tags: state.tags.items,
  error: state.errors.item,
  inputHistory: state.inputHistory.item,
  validity: state.validity.item,
})


export default withRouter(
  connect(
    mapStateToProps,{
      loginUser, 
      logoutUser, 
      registerUser, 
      fetchSubjects,
      newError,
      fetchErrorsFilter,
      fetchTagIds,
      fetchTagCounts,
      getInputHistory,
      setInputHistory
    }
  )(ErrorInput)
);


// WEBPACK FOOTER //
// ./src/components/ErrorInput.js